export default {"src":"/_next/static/media/mnz.1b0ed6f4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};